export default "__VITE_ASSET__510d6af0__"